module.exports = __webpack_public_path__ + "static/media/canceled-order-icon.acdab473.svg";